if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /* Submithandler
        *
        * Handler for submitting forms via AJAX
        * @param container - jQuery representation of element containing the form elements to be submitted
        * @param submitBtn - (optional) jQuery representation of submit button
        *
        * */
        ZZ.SubmitHandler = function(container, submitBtn) {
            var base = this;
            base.container = container;

            // remove any no-javascript specific input fields
            base.container.find(".no-js").remove();

            base.form = base.container.closest("form");
            base.submitBtn = submitBtn || base.container.find("[type=submit]");

            // make sure all submit buttons have an unique ID
            base.submitBtn.each(function() {
                if (typeof $(this).attr("id") === "undefined") {
                    $(this).attr("id", "submit_id_" + new Date().valueOf());
                }
            });

            function assignSubmitAction() {
                base.submitBtn.on("click", function(e) {
                    e.preventDefault();

                    var parameters = base.container.find(":input").serialize(),
                        url =
                            base.form.attr("data-async-action") ||
                            base.form.attr("action"),
                        method = base.form.attr("method"),
                        submitId = $(e.currentTarget).attr("id");

                    // add ZZ specific security token only with method post
                    var securityToken = $(":input[name=ZZCSRFToken]:first");
                    if (
                        securityToken.length > 0 &&
                        method.toString().toUpperCase() !== "GET"
                    ) {
                        parameters += "&" + securityToken.serialize();
                    }

                    var permission = base.onBeforeSubmit();
                    if (typeof permission !== "undefined" && !permission) {
                        return false;
                    } else {
                        base.container.addClass("loading");
                        $.ajax({
                            url: url,
                            dataType: "json",
                            type: method,
                            data: parameters,
                            redirLogout: true, // redirect in case logged out (redirect-proxy.js)
                            success: function(response) {
                                base.container.removeClass("loading");
                                $(window).trigger(
                                    "zz_formsubmit_succes",
                                    submitId
                                );
                                base.handleSubmitResponse(response);
                            },
                            error: function() {
                                base.container.removeClass("loading");
                                base.handleError();
                            }
                        });

                        base.form.submit();
                        return true;
                    }
                });
            }

            assignSubmitAction();
        };

        ZZ.SubmitHandler.prototype = {
            // overload these functions
            onBeforeSubmit: function() {
                // return false to prevent submit
                return true;
            },

            handleSubmitResponse: function(response) {},

            handleError: function() {}
        };
    })(jQuery);
}
